import type { RunningNowFilterableField } from '@kirin/api-client/contracts/shadow-ai-running-now';
import { RUNNING_NOW_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/shadow-ai-running-now';
import { TABLE_IDS } from '@/components/DataTable/tableIds';

export const RUNNING_NOW_FILTER_URL_KEYS = {
  [RUNNING_NOW_FILTERABLE_FIELDS.NAME]: 'n',
  [RUNNING_NOW_FILTERABLE_FIELDS.CATEGORY]: 'cat',
  [RUNNING_NOW_FILTERABLE_FIELDS.USER]: 'u',
  [RUNNING_NOW_FILTERABLE_FIELDS.LOGGED_IN_USER]: 'liu',
  [RUNNING_NOW_FILTERABLE_FIELDS.PID]: 'pid',
  [RUNNING_NOW_FILTERABLE_FIELDS.PORT]: 'prt',
  [RUNNING_NOW_FILTERABLE_FIELDS.STARTED_AT]: 'sa',
} as const satisfies Record<RunningNowFilterableField, string>;

export const RUNNING_NOW_TABLE_CONFIG = {
  tableId: TABLE_IDS.ORGANIZATION.SHADOW_AI.RUNNING,
} as const;
